<style lang="less" type="text/less" scoped>
    .pull-reload{
        position:relative;
        overflow:hidden;
        .hidden{
            position:absolute;
            top:-10px;
            left:0;
            right:0;
            line-height:20px;
            text-align: center;
            overflow: hidden;
            height:20px;
            span{
                color:#999;
                position:absolute;
                top:50%;
                transform:translateY(-50%);
                left:0;
                right:0;
            }
        }
        .transition{
            transition:all ease 0.3s;
        }
        .inner{
            background:#fff;
            overflow: hidden;
        }
    }
</style>
<template>
    <div class="pull-reload" :style="{minHeight:minHeight+'px'}">
        <div class="hidden" :class="{transition:!noAnimation}" :style="{transform: 'translateY(' + (loading?50:pullY)/2 + 'px)'  }">
            <span v-if="!loading">{{ pullY>threshold?"松开":"下拉"}}刷新</span>
            <span v-else>载入中...</span>
        </div>
        <div class="inner" :class="{transition:!noAnimation}" :style="{transform: 'translateY(' + (loading?50:pullY) + 'px)'  }">
            <slot></slot>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    import $ from 'jquery'
    export default {
        props:{
            onReload:{
                type:Function,
                default:function () {}
            }
        },
        data(){
            return {
                pullY:0,
                loading:false,
                noAnimation:false,
                threshold:70,
                minHeight:0
            }
        },
        computed: {},
        methods: {
            onTouchend:function () {
                var vm = this;
                if(this.pullY>this.threshold){
                    this.loading = true;
                    var r = this.onReload();
                    if(r && r.then){
                        r.then(function () {
                            vm.loading = false;
                        }).catch(function () {
                            vm.loading = false;
                        })
                    }
                }
            }
        },
        components: {},
        mounted(){
            var vm = this;
            var $el = $(this.$el);
            var start = false;
            var threshold = null;
            var lastMove = null;
            vm.minHeight = $(window).height() - $el.offset().top + 1;
            $el.on('touchstart',function () {
//                if(vm.$root.scrollTop == 0 ){
                start = true;
//                }
            });
            $(window).on('touchstart',function (e) {
//                if($(window).scrollTop()==0){
                lastMove = e.touches[0].clientY;
//                }
            }).on('touchmove',function (e) {
                if( start && $('body').scrollTop()<=0 && $el.is(':visible') && lastMove!=null){
                    var now = e.touches[0].clientY;
                    var diff = now - lastMove;
                    if(diff>0){ // finger down
                        e.preventDefault();
                    }else{
                        if(vm.pullY>0 ){
                            e.preventDefault();
                        }
                    }

                    if(!threshold){
                        threshold = now;
                    }
                    var targetHeight = now - threshold;
                    vm.pullY =  Math.max(targetHeight,0)/2;
                }
                vm.noAnimation = true;
                lastMove = e.touches[0].clientY;
            }).on('touchend',function () {
                if($el.is(':visible')){
                    vm.onTouchend();
                }
                threshold = null;
                lastMove = null;
                start = false;
                vm.pullY = 0;
                vm.noAnimation = false;
            })
        }
    }
</script>


// WEBPACK FOOTER //
// PullReload.vue?cbfc558e